import i18n from "@/i18n";

const SUPPORTED_LANGS = ["en", "th", "en-XA"] as const;
type SupportedLang = (typeof SUPPORTED_LANGS)[number];

function normalize(lang: string): SupportedLang {
  return (SUPPORTED_LANGS as readonly string[]).includes(lang) ? (lang as SupportedLang) : "en";
}

function applyLang(lang: string) {
  const target = normalize(lang);
  document.documentElement.setAttribute("lang", target);
  document.documentElement.setAttribute("dir", "ltr");
}

let bound = false;

export function initLangAttribute() {
  if (bound) return;
  applyLang(i18n.language);
  i18n.on("languageChanged", applyLang);
  bound = true;
}

export function destroyLangAttribute() {
  if (!bound) return;
  i18n.off("languageChanged", applyLang);
  bound = false;
}
